import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=2e1e63fc&scoped=true"
import script from "./SocialLogin.vue?vue&type=script&lang=js"
export * from "./SocialLogin.vue?vue&type=script&lang=js"
import style0 from "./SocialLogin.vue?vue&type=style&index=0&id=2e1e63fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1e63fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e1e63fc')) {
      api.createRecord('2e1e63fc', component.options)
    } else {
      api.reload('2e1e63fc', component.options)
    }
    module.hot.accept("./SocialLogin.vue?vue&type=template&id=2e1e63fc&scoped=true", function () {
      api.rerender('2e1e63fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SocialLogin.vue"
export default component.exports